import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex mb-1"
}
const _hoisted_2 = { class: "container" }

import { usePaginatedResourcesState } from "@/domains/app/resource";
import { useUser } from "@/domains/auth/user";
import { computed, ref } from "@vue/reactivity";
import BaseList from "../../../search/components/List.vue";
import { ROLE_ADMIN } from "../../users/users";
import { useRoute } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { query } = useRoute();
const selectedScope = ref<"user" | "department" | "country" | "selection">(
    query.user_id !== undefined ? "selection" : "user"
);
const { scope: userScope, user } = useUser();

const getResourcesState = () =>
    usePaginatedResourcesState<any>(
        "sheets",
        true,
        computed(() => {
            const r: Record<string, string> = {
                scope:
                    selectedScope.value === "selection"
                        ? userScope.value ?? "user"
                        : selectedScope.value,
            };
            if (
                selectedScope.value === "selection" &&
                query.user_id !== undefined
            ) {
                r.user_id = query.user_id as string;
            }
            return r;
        })
    );

const makeDriver = () => ({
    loadingKey: "sheets.loading.list",
    getLabel: (sheet: any) => {
        const label = user.value?.roles.includes(ROLE_ADMIN)
            ? `Conducteur #${sheet.user_id}`
            : "";
        const date = new Date(sheet.date);
        return (
            label +
            ` ${("" + date.getDate()).padStart(2, "0")}/${(
                "" +
                (date.getMonth() + 1)
            ).padStart(2, "0")}/${date.getFullYear()}`
        );
    },
});

return (_ctx: any,_cache: any) => {
  const _directive_loading_key = _resolveDirective("loading-key")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(userScope) !== 'user')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_unref(query).user_id !== undefined)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: _normalizeClass(["btn me-1", {
                'btn-light': selectedScope.value !== 'selection',
                'btn-secondary': selectedScope.value === 'selection',
            }]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (selectedScope.value = 'selection'))
              }, " Conducteur selectionné ", 2))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: _normalizeClass(["btn", {
                'btn-light': selectedScope.value !== 'user',
                'btn-secondary': selectedScope.value === 'user',
            }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (selectedScope.value = 'user'))
          }, " Mes fiches ", 2),
          (_unref(userScope) === 'department' || _unref(userScope) === 'country')
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: _normalizeClass(["btn ms-1", {
                'btn-light': selectedScope.value !== 'department',
                'btn-secondary': selectedScope.value === 'department',
            }]),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (selectedScope.value = 'department'))
              }, " Fiches de mon département ", 2))
            : _createCommentVNode("", true),
          (_unref(userScope) === 'country')
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: _normalizeClass(["btn ms-1", {
                'btn-light': selectedScope.value !== 'country',
                'btn-secondary': selectedScope.value === 'country',
            }]),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (selectedScope.value = 'country'))
              }, " Fiches du pays ", 2))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _createVNode(BaseList, {
        title: "Liste des fiches",
        "get-resources-state": getResourcesState,
        "api-resource-base": "sheets",
        "make-item-driver": makeDriver,
        "new-item-route": { name: `sheets.create` },
        "search-placeholder": "référence ou date: MM/AAAA ou saison AAAA-AAAA"
      }, null, 8, ["new-item-route"])
    ])), [
      [_directive_loading_key, 'sheet.list.department']
    ])
  ], 64))
}
}

})